module.exports = __webpack_public_path__ + "HelveticaNeueLTStdBd.042459e5e97943dc3d37.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/HelveticaNeueLTStdBd.woff
// module id = ../../../../../src/assets/fonts/HelveticaNeueLTStdBd.woff
// module chunks = styles